import graphql__6929c99ae199f42a43d0 from "./__generated__/ThemeImage_theme.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";
import classNames from "classnames";
import { colorAndOpacityToRGBA } from "../../Utils/colorUtils";

const ThemeImage = props => {
  const { primaryColor, images } = props.theme;

  if (!images || !images.preview) return null;

  const { preview } = images;
  const className = classNames("theme-image-container", props.className);
  const backgroundColor = colorAndOpacityToRGBA(primaryColor, 0.6);

  return (
    <figure className={className}>
      <img src={preview} className="image-full-width" alt="" />
      <div
        className="theme-image-container-overlay"
        style={{ backgroundColor: backgroundColor }}
      />
    </figure>
  );
};

export default createFragmentContainer(ThemeImage, {
  theme: graphql__6929c99ae199f42a43d0
});
